import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CollaboratorFormModal } from '@/features/Collaborators/Edit/Form/Modais';
import { Collaborator, collaboratorSchemaHelpers } from '@/models';
import { useUpdateCollaboratorMutation } from '@/features/Collaborators/Data';
import { useToast } from '@/hooks/useToast';
import { CapabilitiesFieldset, PerformanceFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';


interface TechUpdateModalProps {
    isOpen: boolean;
    onClose: () => void;
    collaboratorId: string | null;
}

interface TechUpdateModalContentProps {
    collaboratorId: string;
}

const TechUpdateModalContent: React.FC<TechUpdateModalContentProps> = ({ collaboratorId }) => {
    const {
        control,
        setValue,
        watch,
        trigger,
        formState: { errors, isSubmitting }
    } = useFormContext<Collaborator>();

    return (
        <div className="space-y-6">
            {/* PerformanceFieldset - Avaliação de Performance */}
            <div className="-mt-6">
                <PerformanceFieldset
                    context="TECH_UPDATE"
                    control={control}
                    setValue={setValue}
                    watch={watch}
                    errors={errors}
                    isSubmitting={isSubmitting}
                    layout="full"
                />
            </div>

            {/* CapabilitiesFieldset - Tecnologias e Recursos */}
            <CapabilitiesFieldset
                context="TECH_UPDATE"
                control={control}
                setValue={setValue}
                watch={watch}
                trigger={trigger}
                errors={errors}
                isSubmitting={isSubmitting}
                layout="full"
            />
        </div>
    );
};

const TechUpdateModal: React.FC<TechUpdateModalProps> = ({
    isOpen,
    onClose,
    collaboratorId
}) => {
    // Hooks para mutação e toast (igual aos outros modais)
    const updateCollaboratorMutation = useUpdateCollaboratorMutation();
    const { success, error } = useToast();

    const handleSubmit = async (data: Collaborator) => {
        try {
            // 🔄 Configurar updateStatus específico do Tech (igual aos outros modais)
            const updatedData: Collaborator = {
                ...data,
                updatedStatus: {
                    ...data.updatedStatus,
                    byTech: {
                        status: 'UPDATED'
                    }
                }
            };

            // 🚀 Usar mutação real e toBackendData (igual aos outros modais)
            await updateCollaboratorMutation.mutateAsync(
                collaboratorSchemaHelpers.toBackendData(updatedData as any)
            );

            // ✅ Toast de sucesso (igual aos outros modais)
            success('Dados salvos!', 'Informações técnicas atualizadas com sucesso');

        } catch (submitError) {
            console.error('💥 ERRO NO SUBMIT TECH:', submitError);
            const errorMessage = submitError instanceof Error ? submitError.message : 'Erro desconhecido';
            error('Erro ao salvar dados', errorMessage);
            throw submitError;
        }
    };

    if (!isOpen || !collaboratorId) return null;

    // Fieldsets ativos no TECH_UPDATE
    const currentFieldsets = [
        'PerformanceFieldSet',
        'CapabilitiesFieldSet'
    ];

    return (
        <CollaboratorFormModal
            isOpen={isOpen}
            onClose={onClose}
            context="TECH_UPDATE"
            collaboratorId={collaboratorId}
            onSubmit={handleSubmit}
            title="Atualização Técnica"
            maxWidth="max-w-6xl"
            currentFieldsets={currentFieldsets}
        >
            <TechUpdateModalContent collaboratorId={collaboratorId} />
        </CollaboratorFormModal>
    );
};

export default TechUpdateModal; 